// Where a page's back link goes: the page the reader came from, when that is
// one of the two lists of work (the homepage or All work). Every history entry
// opened by a link records the list it was reached from, through any chain of
// articles in between, so an article opened from the homepage leads back to
// the homepage and one opened from All work leads back there. A page opened
// directly, with no recorded origin, falls back to the page's own default.
//
// When the list is behind this page with only the page's own entries between
// (an article's contents links push hashes), the link steps back that many
// entries instead of pushing a new one, so the list is restored at the offset
// the reader left it (App's scroll restoration). Through another article it
// is an ordinary link. Kept in sessionStorage, keyed by history entry, so it
// survives a reload. Read by hooks/useBackLink.
const ROOTS = { "/": "Home", "/work": "All work" };
const STORE = "pf-origins";

export function readOrigins() {
  try {
    return JSON.parse(sessionStorage.getItem(STORE)) || {};
  } catch {
    return {};
  }
}

function write(origins) {
  try {
    sessionStorage.setItem(STORE, JSON.stringify(origins));
  } catch {
    // Storage unavailable: back links use their defaults.
  }
}

// `from` is the pathname that was on screen, `fromKey` its entry and `to` the
// new pathname.
export function originFor(origins, from, fromKey, to, replace = false) {
  const parent = origins[fromKey];
  if (replace) return parent;
  if (to === from) return parent && { root: parent.root, steps: parent.steps && parent.steps + 1 };
  if (from in ROOTS) return { root: from, steps: 1 };
  return parent && { root: parent.root, steps: 0 };
}

// Called by the router for each new entry.
export function recordOrigin(key, from, fromKey, to, replace) {
  const origins = readOrigins();
  const entry = originFor(origins, from, fromKey, to, replace);
  if (!entry) return;
  origins[key] = entry;
  write(origins);
}

// A list never links back to itself (All work reached again through an
// article): that page keeps its default.
export function backFor(entry, fallback, pathname) {
  if (!entry || !(entry.root in ROOTS) || entry.root === pathname) return fallback;
  return { to: entry.root, label: ROOTS[entry.root], steps: entry.steps || 0 };
}
